<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
  </cTable>
</template>

<script>
import cTable from '@/base/common/index';
import { apis } from '@/api/finance/billingRecord';
export default {
  name: "billingRecord",
  components: {
    cTable
  },
  data() {
    return {
      methods: {
        ...apis
      },
      config: {},
      footer: {},
      modals: {
        set: {
          type: 'add',
          methods: {
            ok({ row, close }) {
              let data = this.handleFilterData({ ids: row.ids })
              this.$page.handleRequestMethods('setInvoicedOut', data, true, true).then(res => {
                this.$page.getList();
                close();
              })
            }
          },
          config: {
            title: this.$tz('设置,开票'),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 100
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: '20px'
              }
            },
            rules: {
              finance_invoice_time: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                  type: 'date',
                },
              ],
              remarks: [
                {
                  required: true,
                  message: 'cannot be empty',
                  trigger: 'blur',
                },
              ],
            }
          },
          grid: [
            { finance_invoice_time: 24 },
            { remarks: 24 },
          ],
          fields: [
            {
              name: () => this.$tz('开票,时间'),
              key: 'finance_invoice_time',
              placeholder: () => this.$tz('开票,时间'),
              component: 'DatePicker',
              disabledDate: true,
              bind: {
                type: 'datetime',
                format: 'yyyy-MM-dd HH:mm:ss'
              },
              format: 'YYYY-MM-DD HH:mm:ss',
            },
            {
              key: 'remarks',
              name: () => this.$tz('备注'),
              placeholder() {
                return this.$tz('备注');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 3 },
              },
            },
          ]
        },
      },
      header: {
        searchs: [
          {
            key: 'time_type',
            placeholder() {
              return this.$tz('时间,类型')
            },
            component: 'Select',
            options: [
              { label: this.$tz('申请时间'), value: 1 },
              { label: this.$tz('开票,时间'), value: 2 },
            ],
            optionsFn: '',
            optionsKey: '',
          },
          {
            key: 'startTime',
            placeholder() {
              return this.$tz('请选择,开始,日期');
            },
            component: 'DatePicker',
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: '150px',
              },
            },
          },
          {
            key: 'endTime',
            placeholder() {
              return this.$tz('请选择,结束,日期');
            },
            component: 'DatePicker',
            bind: {
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                },
              },
              style: {
                width: '150px',
              },
            },
          },
          {
            key: 'client_id',
            placeholder() {
              return this.$tz('客户')
            },
            component: 'Select',
            options: [],
            optionsFn: 'customer',
            optionsKey: '',
          },
          {
            key: 'ownership_id',
            placeholder() {
              return this.$tz('所属公司')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getCompanies',
            optionsKey: '',
          },
          {
            key: 'currency',
            placeholder() {
              return this.$tz('币种')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getCurrency',
            optionsKey: '',
          },
          {
            key: 'is_invoice',
            placeholder() {
              return this.$tz('是否,开票')
            },
            component: 'Select',
            options: [],
            optionsFn: 'YesNo',
            optionsKey: '',
          },
          {
            key: 'keywords',
            placeholder() {
              return this.$t('keyword');
            },
            component: 'Input',
            bind: {
              type: 'textarea',
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
            },
            {
              name: () => this.$tz('设置,开票'),
              type: 'set',
              fnName: 'set',
              bind: {
                type: 'primary'
              },
              disabled() {
                return !this.selectAll.length
              }
            },
          ],
          methods: {
            set() {
              this.getModal('set').open({ ids: this.selectAll.map(t => t.id) }, function () {
                this.setTitle(this.$tz('设置,开票'));
              });
            },
            export({ searchForm }) {
              let data = JSON.parse(JSON.stringify(searchForm));
              data.export = 1;
              this.handleRequestMethods("list", data, true, true).then(res => {
                this.openUrl(res.payload);
              });
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          align: 'center',
          width: 50,
        },
        {
          name: () => this.$tz('所属公司'),
          key: 'ownership_name',
          minWidth: 110,
        },
        {
          name: () => this.$tz('公司中文名'),
          key: 'shipper_company_cn',
          minWidth: 110,
        },
        {
          name: () => this.$tz('客户,代码'),
          key: 'account',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,金额'),
          key: 'invoice_amount',
          minWidth: 110,
        },
        {
          name: () => this.$tz('币种'),
          key: 'invoice_amount_currency',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,资料'),
          key: 'invoice_info',
          minWidth: 110,
        },
        {
          name: () => this.$tz('邮箱'),
          key: 'email',
          minWidth: 110,
        },
        {
          name: () => this.$tz('入账,银行'),
          key: 'bank',
          minWidth: 110,
        },
        {
          name: () => this.$tz('入账,时间'),
          key: 'posting_in_time',
          minWidth: 110,
        },
        {
          name: () => this.$tz('有无,合同'),
          key: 'has_contract',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,申请人'),
          key: 'creator_name',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,申请时间'),
          key: 'create_time',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,备注'),
          key: 'apply_remarks',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,时间'),
          key: 'finance_invoice_time',
          minWidth: 110,
        },
        {
          name: () => this.$tz('开票,操作人'),
          key: '',
          minWidth: 110,
        },
      ]
    }
  }
}
</script>

<style scoped></style>